module.exports = __webpack_public_path__ + "img/u0506.de07ad54.png";